import { formatDate } from "date-fns";

import { FinancialTransaction } from "@/interfaces/talk2pay.iterfaces";

const SEPARATOR = ";";
const BOM = "\uFEFF";

const HEADERS = [
  "Data",
  "Transação",
  "Descrição",
  "Tipo",
  "Movimento",
  "ID do pagamento",
  "Valor",
  "Saldo",
];

function escapeCell(value: string | null | undefined): string {
  const text = value ?? "";
  if (/[";\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

function formatAmount(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "";
  return Number(value).toFixed(2).replace(".", ",");
}

export function buildStatementCsv(financialTransaction: FinancialTransaction): string {
  const rows = financialTransaction.transactions.map((transaction) => [
    formatDate(transaction.date, "dd/MM/yyyy"),
    escapeCell(transaction.id),
    escapeCell(transaction.description),
    escapeCell(transaction.type),
    transaction.value >= 0 ? "Crédito" : "Débito",
    escapeCell(transaction.paymentId),
    formatAmount(transaction.value),
    formatAmount(transaction.balance),
  ]);

  const finalBalanceRow = [
    "Saldo final",
    "",
    "",
    "",
    "",
    "",
    "",
    formatAmount(financialTransaction.finalBalance),
  ];

  const lines = [HEADERS, ...rows, finalBalanceRow].map((cells) => cells.join(SEPARATOR));

  return BOM + lines.join("\r\n");
}

export function buildStatementCsvFileName(startDate: Date, endDate: Date): string {
  return `EXTRATO_${formatDate(startDate, "ddMMyyyy")}_${formatDate(endDate, "ddMMyyyy")}.csv`;
}
